import { Container, Navbar, NavDropdown, Nav } from 'react-bootstrap'
import { LinkContainer } from 'react-router-bootstrap'
import { NavLink } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import Popup from '../components/PopupMessage'
import { getUnreadEventsCount } from '../actions/eventActions'
import { useEffect } from 'react'
import NotificationBell from './NotificationBell'

const NavigationBar = () => {
    const dispatch = useDispatch()
    const loginInfo = useSelector(state => state.login)
    const { user, error } = loginInfo
    const { count: unreadEventsCount } = useSelector(state => state.eventUnread)
    const { count: unreadNotificationsCount } = useSelector(state => state.notificationUnread)
    const isAdmin = user.data.isAdmin || user.data.isCoAdmin

    useEffect(() => {
        dispatch(getUnreadEventsCount())
    }, [dispatch])

    const unreadBadge = unreadEventsCount > 0 && (
        <span className='navigation__badge'>{unreadEventsCount > 99 ? '99+' : unreadEventsCount}</span>
    )

    const notificationBadge = unreadNotificationsCount > 0 && (
        <span className='navigation__badge'>{unreadNotificationsCount > 99 ? '99+' : unreadNotificationsCount}</span>
    )

    return (
        <>
            {error && <Popup danger><p>{error}</p></Popup>}

            {/* ========== شريط التنقل العلوي ========== */}
            <Navbar expand="lg" collapseOnSelect className='navigation__navbar'>
                <Container>
                    <LinkContainer to='/home'>
                        <Navbar.Brand className='navigation__brand'>عائلة سعيد بن غنيم</Navbar.Brand>
                    </LinkContainer>
                    <Navbar.Toggle aria-controls="main-nav" />
                    <Navbar.Collapse id="main-nav">
                        <Nav className="navigation__nav">
                            <NotificationBell />
                            <NavDropdown
                                title={`مرحباً ${user.data.firstName}`}
                                id="main-nav-dropdown"
                                className='navigation__dropdown'
                            >
                                <LinkContainer to='/me'>
                                    <NavDropdown.Item>
                                        <i className="fas fa-user-alt"></i> الملف الشخصى
                                    </NavDropdown.Item>
                                </LinkContainer>

                                {isAdmin && (
                                    <LinkContainer to='/admin'>
                                        <NavDropdown.Item>
                                            <i className="fas fa-cog"></i> لوحة الإدارة
                                        </NavDropdown.Item>
                                    </LinkContainer>
                                )}

                                <LinkContainer to='/news'>
                                    <NavDropdown.Item>
                                        <i className="far fa-newspaper"></i> صحيفة الأخبار
                                    </NavDropdown.Item>
                                </LinkContainer>

                                <LinkContainer to='/documents'>
                                    <NavDropdown.Item>
                                        <i className="far fa-folder-open"></i> الوثائق
                                    </NavDropdown.Item>
                                </LinkContainer>

                                <LinkContainer to='/events'>
                                    <NavDropdown.Item>
                                        <span className='navigation__badgeWrap'>
                                            <i className="far fa-calendar-check"></i> الفعاليات
                                            {unreadBadge}
                                        </span>
                                    </NavDropdown.Item>
                                </LinkContainer>
                            </NavDropdown>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>

            {/* ========== التنقل السفلي (هاتف — PWA) ========== */}
            <nav className="mobile-nav">
                <NavLink to='/home' exact className="mobile-nav__item">
                    <i className="fas fa-tree"></i>
                    <span>الشجرة</span>
                </NavLink>

                {isAdmin && (
                    <NavLink to='/admin' className="mobile-nav__item">
                        <i className="fas fa-cog"></i>
                        <span>الإدارة</span>
                    </NavLink>
                )}

                <NavLink to='/news' className="mobile-nav__item">
                    <i className="far fa-newspaper"></i>
                    <span>أخبار</span>
                </NavLink>

                <NavLink to='/documents' className="mobile-nav__item">
                    <i className="far fa-folder-open"></i>
                    <span>وثائق</span>
                </NavLink>

                <NavLink to='/events' className="mobile-nav__item mobile-nav__item--badge">
                    <i className="far fa-calendar-check"></i>
                    {unreadBadge}
                    <span>فعاليات</span>
                </NavLink>

                <NavLink to='/notifications' className="mobile-nav__item mobile-nav__item--badge">
                    <i className="far fa-bell"></i>
                    {notificationBadge}
                    <span>إشعارات</span>
                </NavLink>

                <NavLink to='/me' className="mobile-nav__item">
                    <i className="fas fa-user-alt"></i>
                    <span>ملفي</span>
                </NavLink>
            </nav>
        </>
    )
}

export default NavigationBar
